import EditorialSection from 'components/EditorialSection';
import Section from 'components/Section';
import { forwardRef } from 'react';
import { skillCategories } from './skillsData';
import './index.css';

const Skills = forwardRef(({ id, sectionRef }, ref) => (
  <Section
    className="skills"
    as="section"
    id={id}
    ref={sectionRef || ref}
    aria-labelledby={`${id}-title`}
    tabIndex={-1}
  >
    <EditorialSection
      index={1}
      eyebrow="Skills"
      title="What I work with"
      headingId={`${id}-title`}
    />
    <div className="skills__grid">
      {skillCategories.map(category => (
        <div className="skills__category" key={category.name}>
          <span className="skills__category-label" aria-hidden="true">{category.name}</span>
          <ul className="skills__list" aria-label={category.name}>
            {category.items.map(item => (
              <li className="skills__chip" key={item}>{item}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  </Section>
));

export default Skills;
